import { CollapsibleIsland } from '@ardoq/page-layout';
import { FlexBox } from '@ardoq/layout';
import { StatusType, Tag } from '@ardoq/status-ui';
import { SecondaryButton } from '@ardoq/button';
import { type I18nLocale, t } from '@ardoq/i18n';

type FilterSelectorProps = {
  i18nLocale: I18nLocale;
  componentTypeName: string;
  status?: 'INIT' | 'LOADING' | 'SUCCESS' | 'FAILURE';
  total?: number;
  message?: string;
  filterApplied?: boolean;
  onFetchResults: (componentTypeName: string) => void;
  querySelector: React.ReactElement;
  componentTypePrefix?: string;
  filtersAppliedLabel?: string;
  applyRulesLabel?: string;
  compliantComponentsLabel?: string;
  failedToFetchLabel?: string;
};

export function FilterSelector({
  i18nLocale,
  componentTypeName,
  status = 'INIT',
  total,
  message,
  filterApplied = false,
  querySelector,
  onFetchResults,
  componentTypePrefix = t(
    i18nLocale,
    'integrations:filterSelector.componentTypePrefix',
    'Component type:'
  ),
  filtersAppliedLabel = t(
    i18nLocale,
    'integrations:filterSelector.filtersAppliedLabel',
    'Filters applied'
  ),
  applyRulesLabel = t(
    i18nLocale,
    'integrations:filterSelector.applyRulesLabel',
    'Apply rules'
  ),
  compliantComponentsLabel = t(
    i18nLocale,
    'integrations:filterSelector.compliantComponentsLabel',
    'Compliant components:'
  ),
  failedToFetchLabel = t(
    i18nLocale,
    'integrations:filterSelector.failedToFetchLabel',
    'Failed to fetch'
  ),
}: FilterSelectorProps) {
  return (
    <CollapsibleIsland
      subtitleWidth="medium"
      key={componentTypeName}
      isDefaultExpanded
      title={
        <FlexBox gap="xsmall">
          {componentTypePrefix}
          {componentTypeName}
          {filterApplied && (
            <Tag statusType={StatusType.INFO}>{filtersAppliedLabel}</Tag>
          )}
        </FlexBox>
      }
    >
      {querySelector}
      <FlexBox>
        <SecondaryButton
          isLoading={status === 'LOADING'}
          onClick={() => onFetchResults(componentTypeName)}
        >
          {applyRulesLabel}
        </SecondaryButton>
      </FlexBox>
      {status === 'SUCCESS' && (
        <FlexBox>
          {compliantComponentsLabel} {total}
        </FlexBox>
      )}
      {status === 'FAILURE' && (
        <Tag statusType={StatusType.ERROR}>{message || failedToFetchLabel}</Tag>
      )}
    </CollapsibleIsland>
  );
}
